<template>
	<div id="addinfo">
		<el-form :model="ruleForm" :inline="inline" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
		  <el-form-item label="标题名称" prop="title">
		    <el-input v-model="ruleForm.title"></el-input>
		  </el-form-item>
			<el-form-item label="地址链接">
			  <el-input v-model="ruleForm.url"></el-input>
			</el-form-item>
		  <el-form-item label="模块分类" prop="about">
		    <el-select v-model="ruleForm.about" placeholder="请选择模块分类">
		      <el-option v-for="(item,index) in listinfo" :key="index" :label="item" :value="item"></el-option>
		    </el-select>
		  </el-form-item>
			<editor ref="editor"></editor>
		  <el-form-item>
		    <el-button type="primary" @click="submitForm('ruleForm')">发布</el-button>
		    <el-button @click="resetForm('ruleForm')">重置</el-button>
		  </el-form-item>
		</el-form>
	</div>
</template>

<script>
	import editor from '../editor/editor'
	
	
	export default{
		name:'addinfo',
		props:{
			inline:{
				type:Boolean,
				default:false
			}
		},
		components:{
			editor
		},
		data() {
			return {
				listinfo:['编程工具','Hive工具','Mysql工具','穿越火线',"英雄联盟",'QQ飞车','DNF','csgo','其它辅助','游戏攻略','自我提升',"编程办公","两性相关","其他教程",'网站源码','PSD源码','各类源码','微信技巧','qq技巧','其他技巧','安卓软件','电脑软件','关于我们','公告通知','热门资讯','百度热搜','教程专区'],
				ruleForm: {
					title: '',
					about: '',
					url:''
				},
				rules: {
					title: [
						{ required: true, message: '请输入标题名称', trigger: 'blur' },
						{ min: 3, max: 99, message: '长度在 3 到 99 个字符', trigger: 'blur' }
					],
					about: [
						{ required: true, message: '请选择板块', trigger: 'change' }
					],

				}
			};
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.ruleForm['content'] = this.$refs.editor.html2
						this.$emit('addinfo', this.ruleForm)
						this.ruleForm={
							title: '',
							about: '',
							url:'',
						}
					} else {
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.ruleForm={
					title: '',
					about: '',
					url:'',
				}
			}
		}
	}
</script>

<style scoped>
	
</style>